<template>
  <b-overlay :show="loading">
    <div class="ml-2 mb-2 font-weight-bold">
      <b-link to="/podcasts"><b-icon icon="chevron-left"></b-icon> All Dental Podcast Episodes</b-link>
    </div>

    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <div class="mt-1 mb-3">
              <div class="d-block d-sm-none">
                <img src="@/art/dentaltalk_sm_portrait.png" alt="DentalTalk Podcast-Earn CE" class="img-fluid" />
              </div>
              <div class="d-none d-sm-block d-md-none">
                <img src="@/art/dentaltalk_lg_portrait.png" alt="DentalTalk Podcast-Earn CE" class="img-fluid" />
              </div>
              <div class="d-none d-md-block d-lg-none">
                <img src="@/art/dentaltalk_sm_landscape.png" alt="DentalTalk Podcast-Earn CE" class="img-fluid" />
              </div>
              <div class="d-none d-lg-block d-xl-none">
                <img src="@/art/dentaltalk_lg_portrait.png" alt="DentalTalk Podcast-Earn CE" class="img-fluid" />
              </div>
              <div class="d-none d-xl-block">
                <img src="@/art/dentaltalk_lg_landscape.png" alt="DentalTalk Podcast-Earn CE" class="img-fluid" />
              </div>
          </div>

          <b-alert v-if="error" show variant="danger" class="mt-2">
            {{errorMsg}}
            <!-- TBD error component. -->
          </b-alert>

          <!-- PODCAST SERIES -->
          <!-- <div class="div-section-header">
            <b-row>
              <b-col cols="12">
                <div>
                  <span class="txt-section-title">{{podcastShow.title}}</span>
                </div>
              </b-col>
              <b-col cols="12">
                  <span class="txt-section-subtitle">Sponsor: {{podcastShow.sponsorCompanyName}}</span>
              </b-col>
            </b-row>
          </div> -->

          <!-- turned off - podcast show -->
          <!-- <div v-if="false" class="div-section-body" style="padding: 0 2px 0 3px;">
            <b-row>
              <b-col cols="4" class="text-center">
                  <b-img fluid v-bind:src="podcastShow.photo" class="mt-3" />
              </b-col>
              <b-col cols="8" class="txt-class-blurb mt-2" :inner-html.prop="this.podcastShow.blurb | nl2br"></b-col>
            </b-row>
          </div>
          <b-row class="div-section-header">
            <b-col cols="12">
                <span class="txt-section-subtitle">Available Now: {{podcasts.length | prettyNumber}} Dental Podcast Episodes</span>
            </b-col>
          </b-row> -->

          <!-- Show selected podcast. -->
          <div v-if="haveFeaturedPodcast" class="div-section-body" style="padding: 0 2px 0 3px;">
            <div class="mt-2">
              <b-row class="pb-2" @click.stop.prevent="activateFeaturedRow(podcasts[featuredPodcastIx].hash)">
                  <b-col cols="2" lg="1" class="text-center">
                    <b-link v-if="!activated" @click.stop.prevent="play(featuredPodcastIx)">
                      <b-icon v-if="!topPlaying" icon="play-fill" font-scale="2.5"></b-icon>
                      <b-icon v-if="topPlaying"  icon="pause-fill" font-scale="2.5"></b-icon>
                    </b-link>
                  </b-col>
                  <b-col cols="10" lg="11" style="margin-left: -10px;">
                    <div class="class-title">{{podcasts[featuredPodcastIx].title}}</div>
                    <div class="class-details">
                      {{podcasts[featuredPodcastIx].speakerName}}
                      <br>{{podcasts[featuredPodcastIx].releaseDateUTC | prettyDate}}<span v-if="podcasts[featuredPodcastIx].credits > 0"> - {{podcasts[featuredPodcastIx].credits}} CEU (Self Study)</span>
                      <br><b-icon icon="clock"></b-icon>&nbsp;{{podcasts[featuredPodcastIx].durationSec | prettySeconds }}
                    </div>
                    <div v-show="isActiveFeaturedRow(podcasts[featuredPodcastIx].hash)">
                      <div v-if="podcasts[featuredPodcastIx].credits !== 0.0 && !podcasts[featuredPodcastIx].examTaken">
                        <b-button :to="{ path: '/eval-podcast/'+podcasts[featuredPodcastIx].hash }" size="sm" class="mt-3">Take Exam</b-button>
                      </div>
                      <div v-if="podcasts[featuredPodcastIx].examTaken">
                        <div class="class-details">
                          <span class="red">Exam Completed on {{podcasts[featuredPodcastIx].examDate | prettyDate}}.</span>
                        </div>
                        <certbutton :c="buildClass(podcasts[featuredPodcastIx])" :s="buildStudentData(podcasts[featuredPodcastIx])" alignment="text-left"></certbutton>
                      </div>
                    </div>
                  </b-col>
              </b-row>
            </div>
          </div>

          <div class="div-section-header mb-2">
            <b-row>
              <b-col cols="12">
                  <span class="txt-section-subtitle">More Podcast Episodes You Might Like</span>
                  <!-- <span class="txt-section-subtitle">Available Now: {{podcasts.length | prettyNumber}} Dental Podcast Episodes</span> -->
              </b-col>
            </b-row>
          </div>

          <!-- episodes -->
          <div class="div-section-body">
            <div v-for="(row,ix) in podcasts" v-bind:key="row.id" class="mt-2 mb-2 pointer">
              <b-row @click.stop.prevent="activateRow(row.hash, ix)" class="pb-2">
                  <b-col cols="2" lg="1" :class="['text-center',{ active: isActiveRow(row.hash) }]">
                    <b-link @click.stop.prevent="play(ix)" v-show="isActiveRow(row.hash)">
                      <b-icon v-if="!isRowPlaying(ix)" icon="play-fill" font-scale="2.5"></b-icon>
                      <b-icon v-if="isRowPlaying(ix)"  icon="pause-fill" font-scale="2.5"></b-icon>
                    </b-link>
                  </b-col>
                  <b-col cols="10" lg="11" style="margin-left: -10px;" :class="{ active: isActiveRow(row.hash) }">
                    <div class="class-title">{{row.title}}</div>
                    <div class="class-details">
                      {{row.speakerName}}
                      <br>{{row.releaseDateUTC | prettyDate}}<span v-if="row.credits > 0"> - {{row.credits}} CEU (Self Study)</span>
                      <br><b-icon icon="clock"></b-icon>&nbsp;{{row.durationSec | prettySeconds }}
                    </div>
                    <div v-show="isActiveRow(row.hash)">
                      <div v-if="row.credits !== 0.0 && !row.examTaken">
                        <b-button :to="{ path: '/eval-podcast/'+row.hash }" size="sm" class="mt-3">Take Exam</b-button>
                      </div>
                      <div v-if="row.examTaken">
                        <div class="class-details">
                          <span class="red">Exam Completed on {{row.examDate | prettyDate}}.</span>
                        </div>
                        <certbutton :c="buildClass(row)" :s="buildStudentData(row)" alignment="text-left"></certbutton>
                      </div>
                      <div class="txt-class-blurb mt-2" v-html="row.blurb">
                          <!-- blurb can contain html -->
                      </div>
                    </div>
                  </b-col>

              </b-row>
              <div v-if="ix < numPodcasts-1" class="w-100" style="margin-left:-5px; border-bottom: 1px solid #CCC;"></div>
            </div>
          </div>

        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */
'use strict'

import service from "@/service/service";
import utils from "@/utils/utils";
import EventBus from '@/plugins/eventbus'

export default {
  name: "PodcastSeries",
  data() {
    return {
      debug: false,
      error: false,
      errorMsg: null,
      loading: true,
      activated: false,   // set to true on first call to activateRow
      msg: "Podcast Series",
      studentData: {status: false},
      studentHash: this.$root.getToken(),
      podcastHash: null,
      podcastShowHash: null,
      podcastShow: {status: false},
      podcasts: [],
      curPodcastIx: -1,  // less than zero to init
      featuredPodcastIx: -1,  // less than zero, top podcast
      playing: false
    }
  },
  props: {
    // route set to use props mapped to url parameters
    p: {
      type: String,
      default: null
    },
    ps: {
      type: String,
      default: ""
    }
  },
  computed: {
    haveFeaturedPodcast() {
      return (this.featuredPodcastIx >= 0)
    },
    topPlaying () {
      // return true if top/featured podcast playing
      return (this.featuredPodcastIx == this.curPodcastIx) && this.playing
    },
    numPodcasts() {
      return this.podcasts.length
    }
   },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    buildClass(podcast) {
      let aout = {
        status: true,
        classId: podcast.id,
        className: podcast.title,
        speakerName: null,  // speaker name not used
        podcastHash: podcast.hash,
        classHash: null,
        description: podcast.description
      }
      return aout
    },
    buildStudentData(data) {
      let aout = {
        status: true,
        hash: this.studentHash,
        name: this.$root.getStudentName(),
        examDate: data.examDate,
        credits: data.credits,
        ceTypeId: data.ceTypeId
      }
      return aout
    },
    isRowPlaying(ix) {
      let aout = this.activated && (ix == this.curPodcastIx) && this.playing
      return aout
    },
    isActiveRow(hash) {
      return ( this.activated && this.podcastHash == hash)
    },
    isActiveFeaturedRow(hash) {
      return ( !this.activated && this.podcastHash == hash)
    },
    activateFeaturedRow(hash, ix) {
      this.activated = false
      this.podcastHash = hash
      this.curpodcastIx = ix

    },
    activateRow(hash) {
      this.activated = true
      this.podcastHash = hash
    },
    play(ix) {   // this.podcasts[ix]
        if (this.debug) console.log(`playing ix: ${ix}  cur: ${this.curPodcastIx}`)
        if (this.curPodcastIx == ix) {
            // toggle play on current ix
            if (!this.playing) {
              // play
              EventBus.$emit('podcast-play',null)
            } else {
              // pause
              this.pause()
            }
        }
        else {  // playing new podcast
          if (this.curPodcastIx >= 0 && this.playing) {
            this.pause()  // pause existing podcast
          }
          this.curPodcastIx = ix
          this.podcastHash = this.podcasts[ix].hash
          // log play of new podcast
          let data = {
            title: this.podcasts[ix].title,
            mp3: this.podcasts[ix].mp3
          }
          EventBus.$emit('podcast-play',data)
        }
    },
    pause() {
      EventBus.$emit('podcast-pause', null)
    },
    logPlay() {
      service
        .podcastView(this.podcastHash, this.studentHash)
        .then(
          (res => {
            if (this.debug) console.log(res)
            if (res.status) {
              // not much to do...?
            }
            else {
              this.error = true
              this.errorMsg = 'Error logging podcast play.'
            }
          }).bind(this)
        )
        .finally(e => {
          if (this.debug) console.log(`finally... ${ix}`)
        })
        .catch(e => {
          this.error = true
          this.errorMsg = 'System error. Logging API failure.'
          console.log(e)
        })

    }
  },
  created() {
    this.podcastShowHash = this.ps || this.$route.query.ps || null
    this.podcastHash = this.p || this.$route.query.p || null  // featured podcast

    this.curPodcastIx = -1
    this.featuredPodcastIx = -1
    this.activated = false

    EventBus.$on( 'podcast-play-event',  (function () {
      if (this.debug) console.log(`podcast-play-event`)
      this.playing = true
      this.logPlay()
    }).bind(this))
    EventBus.$on( 'podcast-pause-event', (function () {
      if (this.debug) console.log(`podcast-pause-event`)
      this.playing = false
    }).bind(this))

    if (this.podcastShowHash) {
      this.loading = true
      service
        .getPodcastShow(this.podcastShowHash, this.studentHash)
        .then(
          (res => {
            // console.log(`back from getPodcastShow!`);
            if (this.debug) console.log(res);
            if (res.status && res.rowCount !== 0) {
              this.podcastShow = res.data[0]
              this.podcasts = res.podcasts.data
              if (this.podcastHash && this.podcasts.length !== 0) {
                // console.log(`podcastHash ${this.podcastHash} plen: ${this.podcasts.length}`)
                for(let ix=0; ix < this.podcasts.length; ix++) {
                  // console.log(`testing podcastHash ${this.podcastHash} phash: ${this.podcasts[ix].hash}`)
                  if (this.podcastHash == this.podcasts[ix].hash) {
                    // console.log(`this.featuredPodcastIx ${this.featuredPodcastIx}`)
                    this.featuredPodcastIx = ix // set featured ix
                    break
                  }
                }
                // let arr = this.podcasts.filter( row => row.hash == this.podcastHash)
                // if (arr.length > 0) {
                //   this.podcast = arr[0]
                // }
              }
            }
            else {
              this.error = true
              this.errorMsg = "Server error. Try later."
            }
          }).bind(this)
        )
        .finally(e => {
          this.loading = false
          if (this.debug) console.log(`finally...`);
        })
        .catch(e => {
          this.error = true
          this.errorMsg = "Error accessing API."
          console.log(e)
        })
    }
    else {
        // flag error!
        this.error = true
        this.errorMsg = "Go back and select podcast episode."
    }
    // this.error = this.$root.getClassId() === 0;
  },
  mounted () {
    if (this.debug) console.log('podcast mounted')
  },
  beforeDestroy() {
    if (this.debug) console.log(`podcast destroyed`)
    this.activated = false
    this.featuredPodcastIx = -1
    this.curPodcastIx = -1
    // this.podcastShow = {status: false}
    // this.podcasts = []
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.active2 {
  border: 1px solid red;
  background-color: #EEE;
}
</style>



// WEBPACK FOOTER //
// src/components/Podcast.vue